
import {Scene} from "@babylonjs/core/scene";
import {Color4} from "@babylonjs/core/Maths/math.color";
import {Vector3} from "@babylonjs/core/Maths/math";
import {ArcRotateCamera} from "@babylonjs/core/Cameras/arcRotateCamera";
import {HemisphericLight} from "@babylonjs/core/Lights/hemisphericLight";
import {PointLight} from "@babylonjs/core/Lights/pointLight";

import { GLTF2Export } from '@babylonjs/serializers/glTF';

import OnScreen from "onscreen";

import {Cuboid, ContainerCuboid, FloorCuboid} from "./cuboid";

import SceneGUI from "./scenegui";

var colorMap= [
    [0.12156862745098039, 0.4666666666666667, 0.7058823529411765],
    [0.6823529411764706, 0.7803921568627451, 0.9098039215686274],
    [1.0, 0.4980392156862745, 0.054901960784313725],
    [1.0, 0.7333333333333333, 0.47058823529411764],
    [0.17254901960784313, 0.6274509803921569, 0.17254901960784313],
    [0.596078431372549, 0.8745098039215686, 0.5411764705882353],
    [0.8392156862745098, 0.15294117647058825, 0.1568627450980392],
    [1.0, 0.596078431372549, 0.5882352941176471],
    [0.5803921568627451, 0.403921568627451, 0.7411764705882353],
    [0.7725490196078432, 0.6901960784313725, 0.8352941176470589],
    [0.5490196078431373, 0.33725490196078434, 0.29411764705882354],
    [0.7686274509803922, 0.611764705882353, 0.5803921568627451],
    [0.8901960784313725, 0.4666666666666667, 0.7607843137254902],
    [0.9686274509803922, 0.7137254901960784, 0.8235294117647058],
    [0.4980392156862745, 0.4980392156862745, 0.4980392156862745],
    [0.7803921568627451, 0.7803921568627451, 0.7803921568627451],
    [0.7372549019607844, 0.7411764705882353, 0.13333333333333333],
    [0.8588235294117647, 0.8588235294117647, 0.5529411764705883],
    [0.09019607843137255, 0.7450980392156863, 0.8117647058823529],
    [0.6196078431372549, 0.8549019607843137, 0.8980392156862745],

    [0.2235294117647059,  0.23137254901960785, 0.4745098039215686 ],  // 393b79
    [0.3215686274509804,  0.32941176470588235, 0.6392156862745098 ],  // 5254a3
    [0.4196078431372549,  0.43137254901960786, 0.8117647058823529 ],  // 6b6ecf
    [0.611764705882353,   0.6196078431372549,  0.8705882352941177 ],  // 9c9ede
    [0.38823529411764707, 0.4745098039215686,  0.2235294117647059 ],  // 637939
    [0.5490196078431373,  0.6352941176470588,  0.3215686274509804 ],  // 8ca252
    [0.7098039215686275,  0.8117647058823529,  0.4196078431372549 ],  // b5cf6b
    [0.807843137254902,   0.8588235294117647,  0.611764705882353  ],  // cedb9c
    [0.5490196078431373,  0.42745098039215684, 0.19215686274509805],  // 8c6d31
    [0.7411764705882353,  0.6196078431372549,  0.2235294117647059 ],  // bd9e39
    [0.9058823529411765,  0.7294117647058823,  0.3215686274509804 ],  // e7ba52
    [0.9058823529411765,  0.796078431372549,   0.5803921568627451 ],  // e7cb94
    [0.5176470588235295,  0.23529411764705882, 0.2235294117647059 ],  // 843c39
    [0.6784313725490196,  0.28627450980392155, 0.2901960784313726 ],  // ad494a
    [0.8392156862745098,  0.3803921568627451,  0.4196078431372549 ],  // d6616b
    [0.9058823529411765,  0.5882352941176471,  0.611764705882353  ],  // e7969c
    [0.4823529411764706,  0.2549019607843137,  0.45098039215686275],  // 7b4173
    [0.6470588235294118,  0.3176470588235294,  0.5803921568627451 ],  // a55194
    [0.807843137254902,   0.42745098039215684, 0.7411764705882353 ],  // ce6dbd
    [0.8705882352941177,  0.6196078431372549,  0.8392156862745098 ],  // de9ed6

    [0.19215686274509805, 0.5098039215686274,  0.7411764705882353  ],  // 3182bd
    [0.4196078431372549,  0.6823529411764706,  0.8392156862745098  ],  // 6baed6
    [0.6196078431372549,  0.792156862745098,   0.8823529411764706  ],  // 9ecae1
    [0.7764705882352941,  0.8588235294117647,  0.9372549019607843  ],  // c6dbef
    [0.9019607843137255,  0.3333333333333333,  0.050980392156862744],  // e6550d
    [0.9921568627450981,  0.5529411764705883,  0.23529411764705882 ],  // fd8d3c
    [0.9921568627450981,  0.6823529411764706,  0.4196078431372549  ],  // fdae6b
    [0.9921568627450981,  0.8156862745098039,  0.6352941176470588  ],  // fdd0a2
    [0.19215686274509805, 0.6392156862745098,  0.32941176470588235 ],  // 31a354
    [0.4549019607843137,  0.7686274509803922,  0.4627450980392157  ],  // 74c476
    [0.6313725490196078,  0.8509803921568627,  0.6078431372549019  ],  // a1d99b
    [0.7803921568627451,  0.9137254901960784,  0.7529411764705882  ],  // c7e9c0
    [0.4588235294117647,  0.4196078431372549,  0.6941176470588235  ],  // 756bb1
    [0.6196078431372549,  0.6039215686274509,  0.7843137254901961  ],  // 9e9ac8
    [0.7372549019607844,  0.7411764705882353,  0.8627450980392157  ],  // bcbddc
    [0.8549019607843137,  0.8549019607843137,  0.9215686274509803  ],  // dadaeb
    [0.38823529411764707, 0.38823529411764707, 0.38823529411764707 ],  // 636363
    [0.5882352941176471,  0.5882352941176471,  0.5882352941176471  ],  // 969696
    [0.7411764705882353,  0.7411764705882353,  0.7411764705882353  ],  // bdbdbd
    [0.8509803921568627,  0.8509803921568627,  0.8509803921568627  ],  // d9d9d9
    ];

class PackScene {

    constructor(engine,
                canvas,
                setFullscreen,
                translation) {

        this.os = new OnScreen();
        this.onScreen = true;
        this.visible = true;

        this.setFullscreen = () => {
            };

        if (setFullscreen) {
            this.setFullscreen = setFullscreen;
            }

        this.translation = translation;

        this.labeled = true;
        this.autoRotate = true;

        this.containerId = null;
        this.level = null;

        this.materialCache = {};
        this.boxCache = [];
        this.containerMaterial = null;

        this.boxes = [];

        this.engine = engine;
        this.canvas = canvas;

        // This creates a basic Babylon Scene object (non-mesh)
        this.scene = new Scene(this.engine);

        //this.scene.clearColor = new Color4(1.0, 1.0, 1.0, 1.0);
        //this.scene.ambientColor = new Color4(0.9, 0.9, 0.9, 1.0);

        // This creates a light, aiming 0,1,0 - to the sky (non-mesh)
        var light = new HemisphericLight("light", new Vector3(0, 1, 0), this.scene);
        var light2 = new HemisphericLight("light2", new Vector3(0, -1, 0), this.scene);
        var pl = new PointLight("pl", Vector3.Zero(), this.scene);
        pl.intensity = 0.5;

        // Default intensity is 1. Let's dim the light a small amount
        light.intensity = 0.7;

        // This creates and positions a free camera (non-mesh)
        this.camera = new ArcRotateCamera("Camera", -Math.PI / 4, Math.PI / 4, 2, new Vector3.Zero(), this.scene);

        // This attaches the camera to the canvas
        this.camera.attachControl(this.canvas, true);

        this.camera.useAutoRotationBehavior = true;
        this.camera.autoRotationBehavior.idleRotationSpeed = 0.1;
        this.camera.autoRotationBehavior.idleRotationWaitTime = 10000;
        this.camera.autoRotationBehavior.idleRotationSpinupTime = 10000;
        this.camera.useAutoRotationBehavior = this.autoRotate;

        this.sceneGUI = new SceneGUI(this);

        canvas.addEventListener("wheel", this.WheelHandler, false);

        this.os.on("enter","#sceneCanvas",() => {
            this.onScreen = true;
            this.setVisibility(this.visible, this.onScreen);
            });

        this.os.on("leave","#sceneCanvas",() => {
            this.onScreen = false;
            this.setVisibility(this.visible, this.onScreen);
            });

        this.visibilityListener = document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === 'visible') {
                this.visible = true;
                } else {
                this.visible = false;
                }
            this.setVisibility(this.visible, this.onScreen);
            });
        }

    updateScene = (cuboids, containers)  => {

        if (cuboids.length < 1) {
            this.valid = false;
            this.filter(999999999, -1);
            return;
            }

        var cacheEntries = Object.keys(this.materialCache).length;
        if (cacheEntries > 2 * cuboids.length) {
            for (var material in Object.values(this.materialCache)) {
                //material.dispose();
                }
            this.materialCache = {};
            }

        this.valid = true;
        // ---------------------------------------------------
        // Remove all boxes
        while (true) {
            var thisBox = this.boxes.pop();
            if (!thisBox) {
                break;
                }
            thisBox.freeBox();
            }
        // ------------------------------------------------------

        var xMax = 0;
        var yMax = 0;
        var zMax = 0;
        var cMax = 0;

        for (var i in containers) {
            var container = containers[i];
            if (!container.count) {
                container.count = 1;
            }
            xMax = Math.max(xMax, container.depth);
            yMax = Math.max(yMax, container.height);
            zMax = Math.max(zMax, container.width);
            cMax += container.count;
        }

        var allMax = Math.max(Math.max(xMax, yMax), zMax);
        if (allMax > 3000) {
            this.scaling = 0.1;
            } else {
            this.scaling = 1.0;
            }

        this.xFactor = xMax * 1.3;
        this.zFactor = zMax * 1.3;
        this.cFactor = Math.floor(Math.sqrt(cMax - 1)) + 1;
        this.delta = allMax * 0.015 * this.scaling;

        if (this.scaling < 0.5) {
            this.delta = allMax * 0.03 * this.scaling;
            }

        this.xMax = xMax;
        this.yMax = yMax;
        this.zMax = zMax;
        this.cMax = cMax;

        // This creates and positions a free camera (non-mesh)
        //this.camera.radius = 4 * this.cFactor * this.xFactor;
        this.aimAt(0);
        this.camera.radius = 1.1 * this.cFactor * this.xFactor * this.scaling;

        var thisBox;

        var floorColor = new Color4(0.6, 0.6, 0.6, 0.7);

        thisContainer = {c: 0, x:-5, y:-1, z:-5, depth: (Math.floor((cMax - 1) / this.cFactor) + 1) * xMax * 1.5, height: 1, width: this.cFactor  * zMax * 1.5};
        thisBox = new FloorCuboid(thisContainer, floorColor, this);
        this.boxes.push(thisBox);

        var containerColor = new Color4(0.7, 0.7, 0.7, 0.7);
        var c = 0
        for (var i in containers) {
            for (var j = 0; j < containers[i].count; j++) {

                var thisContainer = {...containers[i]};
                thisContainer.c = c;
                thisBox = new ContainerCuboid(thisContainer, containerColor, this);
                this.boxes.push(thisBox);
                c += 1;
                }
            }

        for (var i in cuboids) {
            var cuboid = cuboids[i];
            var id = cuboid.id;
            var selectedColor = colorMap[id % colorMap.length];
            var color = new Color4(selectedColor[0], selectedColor[1], selectedColor[2], 1.0);

            thisBox = new Cuboid(cuboid, color, this);

            this.boxes.push(thisBox);
            }

        for (var i in this.boxes) {
            this.boxes[i].create(this.labeled);
            }

        this.sceneGUI.updateGUI(cMax, yMax);
        }

    filter = (containerId, level) => {
        for (var i in this.boxes) {
            if (i > 0) {        // Ignore floor
                this.boxes[i].filter(containerId, level);
                }
            }
        }

    updateContainer = (value) => {
        value = Math.floor(value);
        if (value == 0) {
            value = null;
            }
        this.containerId = value;

        this.filter(this.containerId, this.level);

        if (value == null) {
            value = 0;
            }
        this.aimAt(value);
        }

    updateLevel = (value) => {
        if (this.valid) {
            this.level = value;

            this.filter(this.containerId, this.level);
            }
        }

    updateLabeled = (value) => {
        this.labeled = ! this.labeled;

        for (var i in this.boxes) {
            this.boxes[i].setLabeled(this.labeled);
            }
        }

    updateAutoRotate = (value) => {
        this.autoRotate = ! this.autoRotate;
        this.camera.useAutoRotationBehavior = this.autoRotate;
        }

    setVisibility = (visible, onScreen) => {
        this.camera.useAutoRotationBehavior = this.autoRotate && visible && onScreen;
        }

    aimAt = (value) => {
        value = Math.floor(value) - 1;

        var target = new Vector3.Zero();

        if (value < 0 ){
            for (var i = 0; i < this.cMax; i++) {
                target = target.add(this.getMiddle(i));
                }
            target = target.scale(1.0/Math.max(1.0, this.cMax));

            } else {
            target = this.getMiddle(value);
            }
        this.camera.setTarget(target);
        }

    getMiddle = (value) => {

        var ret = new Vector3(this.scaling * (((value - value % this.cFactor) / this.cFactor) * this.xFactor + this.xMax / 2), this.scaling * this.yMax / 2, this.scaling * ((value % this.cFactor)  * this.zFactor + this.zMax / 2));
        return ret;
        }

    render= () => {
        this.scene.render();
        }

    //toPng = (success) => {
    //    Tools.CreateScreenshot(this.engine,
    //        this.camera,
    //        1000,
    //        success);
    //    }

    flushCache = () => {
        while (true) {
            var freeBox = this.boxCache.pop();
            if (!freeBox) {
                break;
                }
            freeBox.dispose();
            }
        }

    toGlb = (glbDone) => {
        console.log("Flushing cache");
        this.flushCache();
        console.log("Call GLB Async");
        GLTF2Export.GLBAsync(this.scene, "packScene.glb").then((glb) => {
            console.log("File created");
            glb.downloadFiles();
            console.log("File downloaded");
            if (glbDone) {
                glbDone();
                }
            });
        }

    toFullscreen = () => {

        this.setFullscreen(true);
        this.engine.enterFullscreen(false);
        }

    WheelHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        }


    dispose = () => {

         if (this.visibilityListener) {
            document.removeEventListener("visibilitychange", this.visibilityListener);
            this.visibleListener = null;
            }

        if (this.os) {
            this.os.off("enter","#sceneCanvas");
            this.os.off("leave","#sceneCanvas");
            this.os = null;
            }

        this.canvas.removeEventListener("wheel", this.WheelHandler);

        try {
            this.scene.dispose();
        } catch (e) {}
        }
    }

export default PackScene;